import React from "react";
import Products from "./Products";

const Store = () => {
  return (
    <div>
      <Products />
    </div>
  );
};

export default Store;
